import { ModelModuleChip } from '#components/model-module-chip/model-module-chip.js';
import { createModuleFilterMenuItem } from '../utils/create-module-filter-menu-item.js';

import type { ModelModuleChipProps } from '#components/model-module-chip/model-module-chip.js';

export type AnalysisResultsModuleChipProps = Omit<ModelModuleChipProps, 'renderAdditionalMenuItems'> & {
	/**
	 * Click-through that adds the module reference designator to the parent
	 * grid's filter model. Omit when the chip is rendered outside a filterable
	 * grid.
	 */
	handleAddModuleFilter?: (moduleReferenceDesignator: string) => void;
};

/**
 * A wrapper around ModelModuleChip that automatically includes the "Add to Design Object Filter"
 * menu item for use in the analysis results page.
 */
export function AnalysisResultsModuleChip({
	moduleReferenceDesignator,
	handleAddModuleFilter,
	...props
}: AnalysisResultsModuleChipProps) {
	return (
		<ModelModuleChip
			moduleReferenceDesignator={moduleReferenceDesignator}
			renderAdditionalMenuItems={createModuleFilterMenuItem(moduleReferenceDesignator, handleAddModuleFilter)}
			{...props}
		/>
	);
}
